import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.sort";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
import AliyunOSS from "components/AliyunOSS.vue";
import CreateFoleder from "components/CreateFolder.vue";
import PreparingCourseware from "components/PreparingCourseware.vue";
import UrlUploadSource from "components/AliyunOSS/UrlUploadSource.vue"; // import ManagerShare from "components/ManagerShare.vue";

export default Vue.extend({
  components: {
    "aliyun-oss": AliyunOSS,
    "create-folder": CreateFoleder,
    "Url-Upload-Source": UrlUploadSource,
    // ManagerShare,
    PreparingCourseware: PreparingCourseware
  },
  data: function data() {
    return {
      name: "",
      txtsourceUrl: "",
      files: [],
      tabNameList: ["source", "question", "test"],
      activeName: "source",
      loadingShow: false,
      noDataShow: false,
      source: [{
        label: "",
        pageSize: 15,
        pageIndex: 0,
        totalCount: 0,
        name: "source",
        list: [],
        nodePathList: []
      }],
      tabPosition: "top",
      isShow_source: true,
      courseName: "22",
      newFolderId: "",
      previewShow: false,
      dataCount: 1,
      firstcome: true,
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      dialogVisible: false,
      FolderId: "",
      Id: "",
      courseWare: {
        Id: "",
        CourseWareName: ""
      },
      beforeDate: {
        beforeName: "",
        isReturn: true
      },
      menuShow: false,
      checked: false,
      ids: [],
      deleteList: [],
      dataList: [],
      checkedList: [],
      fId: "",
      rdialogVisible: false,
      pathdata: [{
        label: "",
        id: ""
      }],
      defaultProps: {
        children: "children",
        label: "label"
      },
      nodeTree: [],
      sourceId: "",
      SourceId: "",
      docextension: "",
      newCourseId: this.$route.params.courseId,
      CourseWareType: 0,
      defaultCover: require("assets/images/noCover.jpg"),
      // 默认封面
      myid: "",
      otherid: "",
      ThirePartydialogVisible: false,
      SourceIds: [],
      list: [],
      IsState: 0,
      videodialogVisible: false,
      playerOptions: {
        autoplay: true,
        // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:8",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true,
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          src: "http://file.chinahoteledu.com/66ykt/ori/2tv3anmogrronofrjgafcw/ktT7n7tMrbnchjbA.mp4"
        }],
        poster: "http://file.chinahoteledu.com/66ykt/ori/2tv3anmogrronofrjgafcw/W7GM6RQCh8GwP2EF.jpg",
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮

        }
      },
      videourl: "https://www.bilibili.com/video/av31263333?from=search&seid=13775199045826412210",
      url_: "",
      //标签
      options4: [],
      loading: false,
      keyword: [],
      mediaType: 3,
      options: [{
        value: 1,
        label: "音频"
      }, {
        value: 2,
        label: "视频"
      }, {
        value: 3,
        label: "文档"
      }, {
        value: 4,
        label: "ppt演示文稿"
      }, {
        value: 5,
        label: "压缩包"
      }, {
        value: 6,
        label: "网页课件"
      }, {
        value: 7,
        label: "图形/图像类"
      }, {
        value: 8,
        label: "动画"
      }, {
        value: 9,
        label: "链接"
      }],
      language: "1",
      sourceone: "1",
      author: "",
      company: "",
      contactInformation: "",
      dialogVisibleLabel: false,
      dialogVisiblePreviewResources: false,
      sourceids: [],
      isChoice: "",
      btnShow: false,
      tabClick: true,
      managerSchool: false,
      managerPatner: false,
      fileList: [],
      //排序
      sortOptions: [{
        value: "-CourseWareType+-DateCreated",
        label: "默认排序"
      }, {
        value: "DateCreated",
        label: "时间正序"
      }, {
        value: "-DateCreated",
        label: "时间倒序"
      }, {
        value: "OrderNumber",
        label: "序号正序"
      }, {
        value: "-OrderNumber",
        label: "序号倒序"
      }],
      sort: "-CourseWareType+-DateCreated",
      sortNum: 0,
      sortId: "",
      sortdialogVisible: false,
      min: 0
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    folderId: {
      type: String,
      default: "0"
    }
  },
  watch: {
    IsState: function IsState() {
      this.ThirePartydialogVisible = false;
      this.getSourceList(1, "source", 0);
    },
    courseId: function courseId() {// this.getSourceList();
    },
    folderId: function folderId(val) {
      this.getSourceList(1, "source", 0);
    }
  },
  created: function created() {
    this.getSourceList(1, this.activeName, this.tabNameList.indexOf(this.activeName));
  },
  methods: {
    // 更改排序方式
    restartSorting: function restartSorting() {
      // this.source[0].pageIndex=1;
      this.getSourceList(this.source[0].pageIndex, this.activeName, this.tabNameList.indexOf(this.activeName));
    },
    // 给课件添加排序
    sortCourseware: function sortCourseware() {
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/sortCourseware", {
        id: this.sortId,
        sortNum: this.sortNum
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$message.success(rst.msg);
          that.getSourceList(that.source[0].pageIndex, that.activeName, that.tabNameList.indexOf(that.activeName));
          that.cancel();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    cancel: function cancel() {
      this.sortdialogVisible = false;
      this.sortNum = 0;
      this.sortId = "";
    },
    // 切换本校、第三方显示隐藏按钮返回函数
    getTabMsg: function getTabMsg(val) {
      if (val == "0" && this.managerSchool == false) {
        this.btnShow = false;
      } else if (val == "1" && this.managerPatner == false) {
        this.btnShow = false;
      } else {
        this.btnShow = true;
      }
    },
    // 点击本校课程显示隐藏按钮返回函数
    getMsg: function getMsg(val) {
      if (val == true) {
        this.btnShow = true;
        this.managerSchool = true;
      } else {
        this.btnShow = false;
        this.managerSchool = false;
      }
    },
    // 点击外校课程显示隐藏按钮返回函数
    getMsgPatner: function getMsgPatner(val) {
      if (val == true) {
        this.btnShow = true;
        this.managerPatner = true;
      } else {
        this.btnShow = false;
        this.managerPatner = false;
      }
    },
    closeSource: function closeSource() {
      this.dialogVisiblePreviewResources = false;
    },
    backtoclass: function backtoclass() {
      this.$router.push({
        name: "ClassNew",
        params: {
          courseId: this.courseId
        }
      });
    },
    GetSourceShow: function GetSourceShow() {
      var _this = this;

      this.$http.post("/api/XOrg/BookMaterial/GetTeacherIsAuthentication", {}).then(function (rst) {
        _this.ThirePartydialogVisible = true;
      });
    },
    addCourseWare: function addCourseWare() {
      this.$refs.addDropdown[0].handleClick();
    },
    handleCommand: function handleCommand(command) {},
    dialogClose: function dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    onAllFilesUpload: function onAllFilesUpload() {
      this.source[0].pageIndex = 1;
      this.getSourceList(1, "source", 0);
    },
    // 获取课件列表
    getSourceList: function getSourceList(idx, type, tabIndex) {
      var _this2 = this;

      this.$http.post("/api/XOrg/BookMaterial/getsourcelist", {
        courseId: this.courseId,
        folderId: this.folderId,
        type: type,
        sort: this.sort,
        page: idx,
        pageSiz: this.source[tabIndex].pageSize
      }).then(function (rst) {
        _this2.source[tabIndex].list = rst.list;
        _this2.loadingShow = false;

        if (rst.list.length == 0) {
          _this2.noDataShow = true;
        } else {
          _this2.noDataShow = false;
        }

        _this2.source[tabIndex].totalCount = rst.pagination.totalCount;
        _this2.source[tabIndex].pageSize = rst.pagination.pageSize;
        _this2.courseName = rst.courseName;
        _this2.source[tabIndex].nodePathList = rst.nodePathList;
        _this2.dataCount = rst.dataCount;
        _this2.myid = rst.myid;
        _this2.otherid = rst.otherid;
        _this2.fileList = [];
        rst.list.forEach(function (item) {
          if (item.CourseWareType == "1") {
            _this2.fileList.push(item.Id);
          }

          _this2.$set(_this2.checkedList, item.Id, false);
        });
        _this2.SourceIds = rst.list.map(function (ele) {
          return ele.Id;
        });
      });
    },
    // 跳转第几页
    onPageChangeHandler: function onPageChangeHandler(idx) {
      this.source[0].pageIndex = idx;
      this.getSourceList(idx, this.activeName, this.tabNameList.indexOf(this.activeName));
    },
    // 一页显示多少条
    handleSizeChange: function handleSizeChange(val) {
      this.source[0].pageSize = val;
      this.source[0].pageIndex = 1;
      this.getSourceList(this.source[0].pageIndex, this.activeName, this.tabNameList.indexOf(this.activeName));
    },
    onTabClickHandler: function onTabClickHandler(tab) {
      var pageIndex = this.source[0].pageIndex;
      this.getSourceList(pageIndex, tab.name, tab.index);

      if (this.activeName == "source") {
        this.isShow_source = true;
      } else {
        this.isShow_source = false;
      }
    },
    overSaveFolderHander: function overSaveFolderHander() {
      this.source[0].pageIndex = 1;
      this.getSourceList(1, "source", 0);
    },
    clickFolderHander: function clickFolderHander(newFolderId) {
      this.$router.push({
        name: "teaShareManagementSource",
        params: {
          courseId: this.courseId,
          folderId: newFolderId
        }
      });
    },
    test: function test() {
      this.$emit("test"); //把a标签的点击事件分发
    },
    previewImage: function previewImage(Id, url, type) {
      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        if (type != "") {
          this.sourceId = Id;
          this.dialogVisiblePreviewResources = true;
        }
      }
    },
    previewElseSource: function previewElseSource() {},
    closePreview: function closePreview() {
      this.previewShow = false;
    },
    // 修改
    updateCourse: function updateCourse() {
      var _this3 = this;

      if (this.name == "") {
        this.$message.warning("课件名称不可为空!");
        return false;
      }

      if (this.CourseWareType == 1) {
        var docname = this.name + "." + this.docextension;
      } else {
        var docname = this.name;
      }

      this.$http.post("/api/XOrg/BookMaterial/updateCourseWare", {
        id: this.SourceId,
        courseWareName: docname,
        txtsourceUrl: this.txtsourceUrl
      }).then(function (rst) {
        if (rst.code == 1) {
          _this3.getSourceList(_this3.source[0].pageIndex, "source", 0);

          _this3.dialogVisible = false;
          _this3.beforeDate.isReturn = false;
        } else {
          _this3.$message.warning(rst.msg);
        }
      });
    },
    update: function update(Id, CourseWareType) {
      this.updateCourse();
    },
    onDropdownClickHandler: function onDropdownClickHandler(cos) {
      switch (cos.type) {
        case "edit":
          if (cos.data.CourseWareType == 1) {
            var str = cos.data.CourseWareName;
            this.name = str.substring(0, str.lastIndexOf("."));
            this.docextension = str.substring(str.lastIndexOf(".") + 1, str.length);
            this.SourceId = cos.data.Id;
            this.dialogVisible = true;
            this.CourseWareType = cos.data.CourseWareType;
          } else {
            var url = cos.data.ADocPrviewUrl;
            this.txtsourceUrl = url;
            this.name = cos.data.CourseWareName;
            this.SourceId = cos.data.Id;
            this.dialogVisible = true;
            this.CourseWareType = cos.data.CourseWareType;
          }

          break;

        case "sort":
          this.sortdialogVisible = true;
          this.sortNum = cos.data.OrderNumber;
          this.sortId = cos.data.Id;
          break;

        case "delete":
          this.isType = cos.data.CourseWareType;
          this.courseWare.Id = cos.data.Id;
          this.deletecourse(cos.data.Id);
          break;

        case "label":
          this.sourceId = cos.data.Id;

          if (cos.data.Keyword[0] == "") {
            this.keyword = [];
          } else {
            this.keyword = cos.data.Keyword;
          }

          if (cos.data.MediaType == 0) {
            this.mediaType = this.GetMediaType(cos.data.DocExtension);
          } else {
            this.mediaType = cos.data.MediaType;
          }

          if (cos.data.Language == "" || cos.data.Language == 0) {
            this.language = "1";
          } else {
            this.language = cos.data.Language;
          }

          if (cos.data.Source == "" || cos.data.Source == 0) {
            this.sourceone = "5";
          } else {
            this.sourceone = cos.data.Source;
          }

          this.author = cos.data.Author;
          this.company = cos.data.Company;
          this.contactInformation = cos.data.ContactInformation;
          this.dialogVisibleLabel = true;
          break;

        default:
          break;
      }
    },
    end: function end() {
      this.sourceId = "";
      this.keyword = [];
      this.mediaType = 3;
      this.language = "1";
      this.sourceone = "1";
      this.author = "";
      this.company = "";
      this.contactInformation = "";
      this.dialogVisibleLabel = false;
    },
    // 删除
    delCourseWare: function delCourseWare(Id) {
      var _this4 = this;

      var self = this;
      var name = this.isType == "1" ? "课件" : "文件夹";
      this.$confirm("此操作将删除该" + name + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var pageIndex = _this4.source[0].pageIndex;

        if (self.source[0].list.length == 1) {
          _this4.source[0].pageIndex = _this4.source[0].pageIndex - 1;
        }

        _this4.$http.post("/api/XOrg/BookMaterial/delCourseWare", {
          id: Id
        }).then(function (rst) {
          if (rst.code == 1) {
            _this4.getSourceList(_this4.source[0].pageIndex, "source", 0);
          } else {
            _this4.$message.warning(rst.msg);
          }
        });
      }).catch(function () {
        _this4.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    deletecourse: function deletecourse(Id) {
      this.delCourseWare(this.courseWare.Id);
    },
    handleSelectionChange: function handleSelectionChange(Id) {
      if (!this.checkedList[Id]) {
        this.checkedList[Id] = false;
        var index = this.dataList.indexOf(Id);
        this.dataList.splice(index, 1);
      } else {
        this.checkedList[Id] = true;
        this.dataList.push(Id);
      }
    },
    // 批量移动
    MoveFolder: function MoveFolder() {
      var _this5 = this;

      this.$http.post("/api/XOrg/BookMaterial/moveFolder", {
        ids: this.dataList,
        fId: this.fId
      }).then(function (rst) {
        if (rst.code > 0) {
          _this5.rdialogVisible = false;

          _this5.$message.success(rst.msg);

          _this5.source[0].list = "";

          _this5.getSourceList(_this5.source[0].pageIndex, "source", 0);

          _this5.dataList = [];
          _this5.fId = "";
        } else {
          _this5.$message({
            type: "warning",
            message: rst.msg
          });
        }
      });
    },
    // 移动取消
    cancelMoveFolde: function cancelMoveFolde() {
      this.getSourceList(this.source[0].pageIndex, "source", 0);
      this.rdialogVisible = false;

      for (var i = 0; i < this.source[0].list.length; i++) {
        if (this.source[0].list[i].checked == true) {
          this.source[0].list[i].checked = false;
        }
      }

      this.dataList = [];
    },
    handleCloseSourceSort: function handleCloseSourceSort() {
      this.getSourceList(this.source[0].pageIndex, "source", 0);
      this.sortdialogVisible = false;
    },
    handleCloseSource: function handleCloseSource() {
      this.getSourceList(this.source[0].pageIndex, "source", 0);
      this.rdialogVisible = false;

      for (var i = 0; i < this.source[0].list.length; i++) {
        if (this.source[0].list[i].checked) {
          this.source[0].list[i].checked = false;
        }
      }

      this.dataList = [];
    },
    DelallCourseWare: function DelallCourseWare() {
      var _this6 = this;

      var self = this;

      if (this.dataList.length == 0) {
        this.$message.warning("请选择课件");
      }

      if (this.dataList.length > 0) {
        this.$confirm("此操作将删除该课件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          var pageIndex = self.source[0].pageIndex;

          if (self.dataList.length == self.source[0].list.length) {
            // pageIndex = pageIndex - 1;
            self.source[0].pageIndex = self.source[0].pageIndex - 1;
          }

          _this6.$http.post("/api/XOrg/BookMaterial/delallCourseWare", {
            ids: self.dataList
          }).then(function (rst) {
            if (rst.code > 0) {
              self.$message.success(rst.msg);
              self.source[0].list = "";
              self.getSourceList(self.source[0].pageIndex, "source", 0);
              self.dataList = [];
            } else {
              self.$message({
                type: "warning",
                message: rst.msg
              });
            }
          });
        }).catch(function () {
          self.$message({
            type: "info",
            message: "已取消删除"
          });
          self.getSourceList(self.source[0].pageIndex, "source", 0);

          for (var i = 0; i < self.source[0].list.length; i++) {
            if (self.source[0].list[i].checked) {
              self.source[0].list[i].checked = false;
            }
          }
        });
      }
    },
    changeMenu: function changeMenu() {
      this.menuShow = !this.menuShow;
    },
    move: function move() {
      var _this7 = this;

      if (this.dataList.length == 0) {
        this.$message.warning("请选择文件");
      } else {
        this.rdialogVisible = true;
        this.GetFolderId();
        this.$http.post("/api/XOrg/BookMaterial/getsourcelist", {
          courseId: this.courseId,
          folderId: this.folderId,
          type: this.activeName,
          sort: 1
        }).then(function (rst) {
          rst.nodePathList.forEach(function (element) {
            _this7.pathdata.push({
              label: element.nodeName,
              id: element.Id
            });
          });
        });
      }
    },
    handleNodeClick: function handleNodeClick(data) {
      this.fId = data.id;
    },
    GetFolderId: function GetFolderId() {
      var _this8 = this;

      this.$http.post("/api/XOrg/BookMaterial/getFolderId", {
        courseId: this.courseId
      }).then(function (rst) {
        var folder = {};
        var resultFolder = [];

        if (rst.list && rst.list.length) {
          folder = {};
          rst.list.forEach(function (el) {
            // el.NodePath
            if (el.ParentId === "0") {
              folder[el.Id] = folder[el.Id] || {
                id: el.Id,
                children: []
              };
              folder[el.Id]["label"] = el.FolderName;
              resultFolder.push(folder[el.Id]);
            } else {
              if (el.NodePath && el.NodePath.length) {
                var paths = el.NodePath.split("/");
                var pathsLen = paths.length - 1;

                for (var i = 0; i <= pathsLen; i++) {
                  var path = paths[i];

                  if (i !== pathsLen) {
                    folder[path] = folder[path] || {
                      id: path,
                      children: []
                    };
                  } else {
                    folder[path] = folder[path] || {
                      id: el.Id
                    };
                    folder[path]["label"] = el.FolderName;
                    var parent = folder[el.ParentId];

                    if (parent && !parent.children) {
                      parent["children"] = [];
                    }

                    folder[el.ParentId].children.push(folder[path]);
                  }

                  folder[el.ParentId] = folder[el.ParentId] || {
                    id: el.ParentId,
                    children: []
                  };
                }
              }
            }
          });
        }

        console.log(resultFolder);
        _this8.nodeTree = [{
          label: "根目录",
          id: "0",
          children: [].concat(resultFolder)
        }];
      });
    },
    AddLabels: function AddLabels() {
      var _this9 = this;

      var word = this.keyword.join(",");
      this.$http.post("/api/XOrg/BookMaterial/addLabels", {
        id: this.sourceId,
        keyword: word,
        mediaType: this.mediaType,
        language: this.language,
        sourceone: this.sourceone,
        author: this.author,
        company: this.company,
        contactInformation: this.contactInformation
      }).then(function (rst) {
        if (rst.code > 0) {
          _this9.$message.success(rst.msg);

          _this9.getSourceList(_this9.source[0].pageIndex, "source", 0);

          _this9.end();
        } else {
          _this9.$message.warning(rst.msg);
        }
      });
    },
    GetMediaType: function GetMediaType(doex) {
      if (doex == ".mp3") {
        return 1;
      } else if (doex == ".mp4") {
        return 2;
      } else if (doex == ".doc" || doex == ".docx" || doex == ".pdf" || doex == ".xlsx" || doex == ".xls" || doex == ".txt") {
        return 3;
      } else if (doex == ".ppt" || doex == ".pptx") {
        return 4;
      } else if (doex == ".zip" || doex == ".rar") {
        return 5;
      } else if (doex == ".ziph") {
        return 6;
      } else if (doex == ".jpg" || doex == ".png" || doex == ".jpeg" || doex == ".svg" || doex == ".ico" || doex == ".gif" || doex == ".hdr") {
        return 7;
      } else if (doex == ".swf") {
        return 8;
      } else if (doex == ".com") {
        return 9;
      } else {
        return "";
      }
    },
    importSource: function importSource() {
      var _this10 = this;

      if (this.sourceids.length == 0) {
        this.$message.warning("请选择课件！");
      } else {
        this.$http.post("/api/XOrg/PartnerShareSource/AddCourseScourse", {
          ids: this.sourceids,
          courseId: this.courseId,
          folderId: this.folderId
        }).then(function (rst) {
          if (rst.code > 0) {
            _this10.$message.success(rst.msg);
          } else {
            _this10.$message({
              type: "warning",
              message: rst.msg
            });
          }

          var checkLength = _this10.list.length;

          for (var i = 0; i < checkLength; i++) {
            if (_this10.list[i].checked) {
              if (_this10.list[i].checked == true) {
                _this10.list[i].checked = false;
              }
            }
          }

          _this10.sourceids = [];
          _this10.source[0].pageIndex = 1;
          _this10.ThirePartydialogVisible = false;

          _this10.getSourceList(1, "source", 0);
        });
      }

      this.disabled = false;
      this.checkStatus = true;
      this.isChoice = "007";
    }
  }
}); // interface IDropdownCommand {
//   type: string;
//   data: {
//     Id: string;
//     CourseWareName: string;
//     CourseWareType: number;
//   };
// }